/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_News_EmptyInputs */

const ja_playdata_news_empty = /** @type {(inputs: Playdata_News_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`まだニュースはありません。`)
};

const en_playdata_news_empty = /** @type {(inputs: Playdata_News_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`There are no news posts yet.`)
};

/**
* | output |
* | --- |
* | "There are no news posts yet." |
*
* @param {Playdata_News_EmptyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_news_empty = /** @type {((inputs?: Playdata_News_EmptyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_News_EmptyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_news_empty(inputs)
	return en_playdata_news_empty(inputs)
});